import { Question, LoveLanguage } from "@/types";

export const APP_VERSION = "3.1.0";

export const IS_BETA = process.env.NEXT_PUBLIC_IS_BETA === "true";

export const SITE_URL =
  process.env.NEXT_PUBLIC_SITE_URL || "https://lovebucket.xyz";

export const OG_IMAGE_URL = `${SITE_URL}/og-image.png`;

export const STORAGE_KEYS = {
  ANSWERS: "love_languages_answers",
  THEME: "love_languages_theme",
  GEO_ASKED: "love_languages_geo_asked",
  VERSES_CACHE: "love_languages_verses_cache",
  CONSENT: "love_languages_consent",
  CONSENT_COUNTRY: "love_languages_consent_country",
} as const;

export const GTM_ID = process.env.NEXT_PUBLIC_GTM_ID || "";

export const CONSENT_EXPIRY_DAYS = 180;

export const EEA_COUNTRIES = [
  "AT", "BE", "BG", "HR", "CY", "CZ", "DK", "EE", "FI", "FR",
  "DE", "GR", "HU", "IE", "IT", "LV", "LT", "LU", "MT", "NL",
  "PL", "PT", "RO", "SK", "SI", "ES", "SE",
  "IS", "LI", "NO",
  "GB",
] as const;

export type EEACountry = (typeof EEA_COUNTRIES)[number];

export interface ConsentState {
  analytics: boolean;
  ads: boolean;
  timestamp: number;
}

export const QUESTIONS: Question[] = [
  {
    id: 1,
    options: [
      { key: "q1_opt1", type: LoveLanguage.A },
      { key: "q1_opt2", type: LoveLanguage.E },
    ],
  },
  {
    id: 2,
    options: [
      { key: "q2_opt1", type: LoveLanguage.B },
      { key: "q2_opt2", type: LoveLanguage.D },
    ],
  },
  {
    id: 3,
    options: [
      { key: "q3_opt1", type: LoveLanguage.C },
      { key: "q3_opt2", type: LoveLanguage.B },
    ],
  },
  {
    id: 4,
    options: [
      { key: "q4_opt1", type: LoveLanguage.D },
      { key: "q4_opt2", type: LoveLanguage.E },
    ],
  },
  {
    id: 5,
    options: [
      { key: "q5_opt1", type: LoveLanguage.E },
      { key: "q5_opt2", type: LoveLanguage.C },
    ],
  },
  {
    id: 6,
    options: [
      { key: "q6_opt1", type: LoveLanguage.B },
      { key: "q6_opt2", type: LoveLanguage.E },
    ],
  },
  {
    id: 7,
    options: [
      { key: "q7_opt1", type: LoveLanguage.C },
      { key: "q7_opt2", type: LoveLanguage.A },
    ],
  },
  {
    id: 8,
    options: [
      { key: "q8_opt1", type: LoveLanguage.E },
      { key: "q8_opt2", type: LoveLanguage.A },
    ],
  },
  {
    id: 9,
    options: [
      { key: "q9_opt1", type: LoveLanguage.B },
      { key: "q9_opt2", type: LoveLanguage.C },
    ],
  },
  {
    id: 10,
    options: [
      { key: "q10_opt1", type: LoveLanguage.A },
      { key: "q10_opt2", type: LoveLanguage.D },
    ],
  },
  {
    id: 11,
    options: [
      { key: "q11_opt1", type: LoveLanguage.B },
      { key: "q11_opt2", type: LoveLanguage.A },
    ],
  },
  {
    id: 12,
    options: [
      { key: "q12_opt1", type: LoveLanguage.D },
      { key: "q12_opt2", type: LoveLanguage.E },
    ],
  },
  {
    id: 13,
    options: [
      { key: "q13_opt1", type: LoveLanguage.A },
      { key: "q13_opt2", type: LoveLanguage.C },
    ],
  },
  {
    id: 14,
    options: [
      { key: "q14_opt1", type: LoveLanguage.B },
      { key: "q14_opt2", type: LoveLanguage.E },
    ],
  },
  {
    id: 15,
    options: [
      { key: "q15_opt1", type: LoveLanguage.A },
      { key: "q15_opt2", type: LoveLanguage.D },
    ],
  },
  {
    id: 16,
    options: [
      { key: "q16_opt1", type: LoveLanguage.E },
      { key: "q16_opt2", type: LoveLanguage.B },
    ],
  },
  {
    id: 17,
    options: [
      { key: "q17_opt1", type: LoveLanguage.D },
      { key: "q17_opt2", type: LoveLanguage.C },
    ],
  },
  {
    id: 18,
    options: [
      { key: "q18_opt1", type: LoveLanguage.A },
      { key: "q18_opt2", type: LoveLanguage.B },
    ],
  },
  {
    id: 19,
    options: [
      { key: "q19_opt1", type: LoveLanguage.E },
      { key: "q19_opt2", type: LoveLanguage.D },
    ],
  },
  {
    id: 20,
    options: [
      { key: "q20_opt1", type: LoveLanguage.D },
      { key: "q20_opt2", type: LoveLanguage.C },
    ],
  },
  {
    id: 21,
    options: [
      { key: "q21_opt1", type: LoveLanguage.B },
      { key: "q21_opt2", type: LoveLanguage.D },
    ],
  },
  {
    id: 22,
    options: [
      { key: "q22_opt1", type: LoveLanguage.C },
      { key: "q22_opt2", type: LoveLanguage.A },
    ],
  },
  {
    id: 23,
    options: [
      { key: "q23_opt1", type: LoveLanguage.C },
      { key: "q23_opt2", type: LoveLanguage.D },
    ],
  },
  {
    id: 24,
    options: [
      { key: "q24_opt1", type: LoveLanguage.B },
      { key: "q24_opt2", type: LoveLanguage.C },
    ],
  },
  {
    id: 25,
    options: [
      { key: "q25_opt1", type: LoveLanguage.D },
      { key: "q25_opt2", type: LoveLanguage.B },
    ],
  },
  {
    id: 26,
    options: [
      { key: "q26_opt1", type: LoveLanguage.E },
      { key: "q26_opt2", type: LoveLanguage.C },
    ],
  },
  {
    id: 27,
    options: [
      { key: "q27_opt1", type: LoveLanguage.A },
      { key: "q27_opt2", type: LoveLanguage.B },
    ],
  },
  {
    id: 28,
    options: [
      { key: "q28_opt1", type: LoveLanguage.C },
      { key: "q28_opt2", type: LoveLanguage.E },
    ],
  },
  {
    id: 29,
    options: [
      { key: "q29_opt1", type: LoveLanguage.D },
      { key: "q29_opt2", type: LoveLanguage.A },
    ],
  },
  {
    id: 30,
    options: [
      { key: "q30_opt1", type: LoveLanguage.E },
      { key: "q30_opt2", type: LoveLanguage.A },
    ],
  },
];
